import { Header } from "components/Common/Header";
import { useTeeTimes } from "hooks/useTeeTimes";
import { useUserData } from "hooks/useUserData";
import { useParams } from "react-router-dom";
import { useEvent } from "hooks/useEvent";
import { useAuth } from "hooks/useAuth";
import "./styles.css";

import { isMatchCompleted } from "utils/match";

import { FinalScorecardSkeleton } from "./FinalScorecardSkeleton";
import { ScorecardItem } from "./components/scorecardItem";
import DogPoundMatchPlay from "./matchPlay/DogPoundMatchPlay";

function TV() {
  const { eventId } = useParams();
  const event = useEvent(eventId);
  const teeTimes = useTeeTimes(eventId);

  const { user } = useAuth();
  const userData = useUserData(user);

  const { teamsPlay } = event ?? {};

  const addTeamNameToEveryUserObject = (teeTimesData) =>
    teeTimesData.map(
      (teeTime) =>
        teeTime.teams?.map((tm) => {
          // eslint-disable-next-line no-param-reassign
          tm.users = tm.users.map((us) => ({
            ...us,
            teamName: tm.name,
            individual: tm.users.length < tm.teamSize,
            playingEventId: teeTime.id,
            ways: tm.ways,
            ball1: tm.ball1,
            ball2: tm.ball2,
          }));
          return tm;
        }) ?? [],
    );

  const usersArray = (teeTimesData2, isTeamsPlay) =>
    teeTimesData2.length && isTeamsPlay
      ? addTeamNameToEveryUserObject(teeTimesData2)
          .flatMap((item) => item.flatMap((team) => team.users))
          .concat()
      : teeTimesData2
          .flatMap(
            (item) =>
              item.users &&
              item.users.map((us) => ({
                ...us,
                teeTimeString: item?.teeTimeString,
                teeTime: item?.teeTime,
              })),
          )
          .filter((el) => el !== undefined);

  const concat = (x, y) => x.concat(y);

  const usersList =
    teeTimes.length && usersArray(teeTimes, teamsPlay)?.reduce(concat, []);

  return (
    <div>
      {teeTimes?.length && event?.numberOfTeeTimes ? (
        <div
          style={{
            width: "max-content",
            justifyContent: "center",
            display: "flex",
            flexDirection: "column",
            margin: "auto",
          }}
        >
          <Header hideQr />
          <ScorecardItem
            users={usersList}
            onHoleClicked={() => {}}
            hasOwnProperty
            final
            holeHandicap={event?.holes?.[0]?.handicap}
            skins={event?.skins}
            carryOver={event?.carryOver}
            ballCount={event?.ballCount}
            teamsPlay={event?.teamsPlay}
            matchType={event?.matchType}
          />

          <DogPoundMatchPlay
            data={usersList}
            teams={
              event.numberOfTeeTimes === 1
                ? teeTimes?.map((i) => i.teams)
                : teeTimes
                    ?.map((i) => i.teams)
                    .flat()
                    .map((team) => ({
                      teamName: team?.name,
                      data: team,
                      playerTeam: team?.users?.some(
                        (u) => u.uid === userData?.uid,
                      ),
                    })) || []
            } // TODO: fix this!
            teamsPlay={teamsPlay}
            numberOfTeeTimes={event.numberOfTeeTimes}
            ballCount={event?.ballCount}
            competedMatch={isMatchCompleted(event ?? {})}
          />
        </div>
      ) : (
        <FinalScorecardSkeleton />
      )}
    </div>
  );
}

export { TV };
